import { DropdownMenu } from './DropdownMenu'
import { StyledMenuItem } from './Navigation.styles'

export function Manage() {
  return (
    <DropdownMenu title="Manage">
      <StyledMenuItem title="My Lanes" url="/preferred-lanes" />
    </DropdownMenu>
  )
}
